// @core/api/endpoints/project/remove_item_from_epic.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ItemResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Remove item from epic
 * Removes the epic association from a project item. The item remains in the project.
 */
export async function RemoveItemFromEpic(
  project_id: string,
  epic_id: string,
  item_id: string,
  options?: RequestOptions
): Promise<ItemResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/epics/:epic_id/items/:item_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':epic_id', encodeURIComponent(epic_id));
  requestPath = requestPath.replace(':item_id', encodeURIComponent(item_id));
  const requestOptions = options;
  return client.delete<ItemResponse>(requestPath, requestOptions);
}
